/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const FastedIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M48.7 28.2c.5-2.2.8-4.4.8-6.7 0-.8-.4-1.2-1.1-1.2H1.6c-.8 0-1.1.4-1.1 1.1 0 2.1.2 4.3.7 6.4 1 4.4 3.2 8.4 6.4 11.5 0 0-.1 0-.1.1-.2.1-.3.2-.4.3-1.5 1.3-1.6 3.6-.3 5.1.7.8 1.7 1.2 2.8 1.2h31.3c.3 0 .5-.1.8-.2.9-.3 1.6-.9 2.1-1.8.4-.9.5-1.8.2-2.7-.3-.8-.8-1.5-1.6-1.9.1-.1.2-.1.2-.2 3-3.1 5.2-6.8 6.1-11zM9.6 44c-.8.1-1.5-.4-1.7-1.1v-.2c-.1-.4 0-.9.2-1.2.2-.4.6-.6 1-.7.2 0 .4-.1.6-.1H40c.3 0 .6 0 .9.1.7.2 1.2 1 1.1 1.8 0 .8-.6 1.4-1.3 1.4H9.6zm30.5-5.3c-.1.1-.3.1-.4.1H10.4c-.2 0-.5-.1-.6-.2-3.6-3.1-6-7.4-6.8-12.1-.2-.9-.3-1.8-.3-2.7 0-.4-.1-.8-.1-1.2v-.2h45.1v.2c-.1 4.3-1.3 8.4-3.6 12-1.3 1.5-2.5 2.9-4 4.1zM6.6 13.2c.2.3.4.7.5 1 .1.2.1.4 0 .5-.1.4.1.9.5 1.1.1.1.3.2.5.2.3 0 .5-.1.7-.3.2-.3.4-.6.5-1v-.2c-.1-.2-.1-.3-.2-.5-.1-.4-.2-.7-.4-1-.2-.3-.3-.7-.5-1-.2-.3-.3-.6-.4-.9-.2-.5-.3-1-.1-1.5v-.1c.1-.3 0-.5-.1-.7-.2-.2-.4-.4-.6-.5-.6-.1-1.1.3-1.2.8-.3 1-.2 2 .2 2.9l.6 1.2zM12 15.7c.1.3.3.5.4.8.2.2.2.5.1.8-.2.4.1.9.5 1.1.2.1.3.1.5.1s.5-.1.6-.3c.4-.3.6-.9.5-1.4-.2-.5-.4-1-.6-1.4-.1-.3-.3-.6-.4-.9-.3-.5-.5-1-.6-1.5 0-.3 0-.7.1-1 0-.5-.3-.9-.7-1-.5-.1-1 .2-1.2.7-.3.8-.3 1.7 0 2.5.3.5.5 1 .8 1.5zM13.2 9c.1.3.3.6.4.8.1.2.1.3 0 .5-.1.5.1.9.5 1.2.1.1.3.1.4.1.3 0 .6-.1.8-.4.4-.4.5-.9.3-1.4-.2-.4-.4-.8-.5-1.2-.2-.3-.3-.7-.5-1-.2-.5-.4-1.1-.6-1.6 0-.4 0-.7.1-1.1v-.2c-.1-.2-.2-.4-.3-.5-.1-.1-.3-.2-.5-.2-.3-.1-.5 0-.7.1-.2.1-.4.4-.4.6-.2 1.3 0 2.5.6 3.6.1.2.3.5.4.7z' />
			<path d='m12.2 33.8-.2-.2c-.6-.6-1.1-1.3-1.6-1.9-1.3-2-2.1-4.2-2.5-6.5 0-.5-.5-.9-1.1-.9-.5.1-.8.5-.8 1.1v.3c.4 2.6 1.4 5.1 3 7.3.6.8 1.3 1.6 2.1 2.3.2.2.4.3.7.3.2 0 .5-.1.6-.3.4-.4.4-1 0-1.4 0 .1-.1 0-.2-.1z' />
		</svg>
	)
}

export default FastedIcon
